// extracted by mini-css-extract-plugin
export var currentRecurrence = "pricings-module--currentRecurrence--vjRKK";
export var link = "pricings-module--link--35gXu";
export var sectionContent = "pricings-module--sectionContent--1c2Nc";